import { WineProduct } from '../types/WineProduct'

export const mockWineProducts: WineProduct[] = [
  // Vini per "Vino da pasto"
  {
    id: 'w1',
    name: 'Chianti Classico',
    producer: 'Antinori',
    year: 2021,
    region: 'Toscana',
    type: 'Rosso',
    price: 18.5,
    description: 'Vino rosso versatile, perfetto per i pasti quotidiani',
    experienceIds: ['a1', 'a3', 'c1'],
    inStock: true,
    rating: 4.2,
    alcoholContent: '13.5%',
  },
  {
    id: 'w2',
    name: 'Vermentino di Sardegna',
    producer: 'Sella & Mosca',
    year: 2022,
    region: 'Sardegna',
    type: 'Bianco',
    price: 12.9,
    description: 'Bianco fresco e minerale, ideale per pesce e piatti leggeri',
    experienceIds: ['a1', 'a5', 'c5'],
    inStock: true,
    rating: 4.0,
    alcoholContent: '12.5%',
  },

  // Vini per cene romantiche
  {
    id: 'w3',
    name: 'Amarone della Valpolicella',
    producer: 'Allegrini',
    year: 2018,
    region: 'Veneto',
    type: 'Rosso',
    price: 45.0,
    description:
      'Vino importante e strutturato, perfetto per occasioni speciali',
    experienceIds: ['b1', 'b2', 'd1'],
    inStock: true,
    rating: 4.8,
    alcoholContent: '15.5%',
  },
  {
    id: 'w4',
    name: 'Franciacorta Brut',
    producer: "Ca' del Bosco",
    year: 2019,
    region: 'Lombardia',
    type: 'Spumante',
    price: 32.0,
    description: 'Bollicine eleganti per celebrare momenti speciali',
    experienceIds: ['b1', 'b2', 'd1', 'd2', 'd6'],
    inStock: true,
    rating: 4.6,
    alcoholContent: '12.5%',
  },

  // Vini per socialità
  {
    id: 'w5',
    name: 'Prosecco Superiore',
    producer: 'Bisol',
    year: 2022,
    region: 'Veneto',
    type: 'Spumante',
    price: 15.5,
    description: 'Perfetto per aperitivi e momenti conviviali',
    experienceIds: ['c2', 'c3', 'c6'],
    inStock: true,
    rating: 4.3,
    alcoholContent: '11.5%',
  },
  {
    id: 'w6',
    name: 'Primitivo di Manduria',
    producer: 'Feudi di San Marzano',
    year: 2021,
    region: 'Puglia',
    type: 'Rosso',
    price: 16.9,
    description: 'Rosso corposo ideale per grigliate e cene informali',
    experienceIds: ['c1', 'c4', 'a3'],
    inStock: true,
    rating: 4.4,
    alcoholContent: '14.5%',
  },

  // Vini per degustazioni
  {
    id: 'w7',
    name: 'Barolo Cannubi',
    producer: 'Marchesi di Barolo',
    year: 2018,
    region: 'Piemonte',
    type: 'Rosso',
    price: 65.0,
    description: 'Grande vino da meditazione e degustazione',
    experienceIds: ['f1', 'f6', 'g1', 'h3'],
    inStock: true,
    rating: 4.9,
    alcoholContent: '14%',
  },
  {
    id: 'w8',
    name: 'Brunello di Montalcino',
    producer: 'Casanova di Neri',
    year: 2017,
    region: 'Toscana',
    type: 'Rosso',
    price: 58.0,
    description: 'Eleganza e struttura per intenditori',
    experienceIds: ['f1', 'f6', 'g1', 'h2'],
    inStock: true,
    rating: 4.7,
    alcoholContent: '14.5%',
  },

  // Vini estivi
  {
    id: 'w9',
    name: 'Verdicchio dei Castelli di Jesi',
    producer: 'Umani Ronchi',
    year: 2022,
    region: 'Marche',
    type: 'Bianco',
    price: 11.5,
    description: "Fresco e beverino, perfetto per l'estate",
    experienceIds: ['g4', 'g5', 'c5'],
    inStock: true,
    rating: 4.1,
    alcoholContent: '12.5%',
  },
  {
    id: 'w10',
    name: "Cerasuolo d'Abruzzo",
    producer: 'Valentini',
    year: 2022,
    region: 'Abruzzo',
    type: 'Rosato',
    price: 14.0,
    description: 'Rosato strutturato, ideale per picnic e spiaggia',
    experienceIds: ['g4', 'g5', 'c5', 'i3'],
    inStock: true,
    rating: 4.5,
    alcoholContent: '13%',
  },

  // Vini da regalo
  {
    id: 'w11',
    name: 'Sassicaia',
    producer: 'Tenuta San Guido',
    year: 2019,
    region: 'Toscana',
    type: 'Rosso',
    price: 180.0,
    description: 'Icona del vino italiano, perfetto per fare bella figura',
    experienceIds: ['h1', 'h3', 'h4', 'e4'],
    inStock: true,
    rating: 5.0,
    alcoholContent: '14%',
  },
  {
    id: 'w12',
    name: 'Tignanello',
    producer: 'Antinori',
    year: 2019,
    region: 'Toscana',
    type: 'Rosso',
    price: 95.0,
    description: 'Super Tuscan di prestigio per occasioni importanti',
    experienceIds: ['h1', 'h3', 'h4', 'e1'],
    inStock: true,
    rating: 4.8,
    alcoholContent: '13.5%',
  },

  // Vini da meditazione
  {
    id: 'w13',
    name: 'Passito di Pantelleria',
    producer: 'Donnafugata',
    year: 2020,
    region: 'Sicilia',
    type: 'Passito',
    price: 28.0,
    description: 'Dolce e complesso, perfetto per la meditazione',
    experienceIds: ['g1', 'g2', 'g6'],
    inStock: true,
    rating: 4.6,
    alcoholContent: '14.5%',
  },
  {
    id: 'w14',
    name: 'Recioto della Valpolicella',
    producer: 'Masi',
    year: 2019,
    region: 'Veneto',
    type: 'Passito',
    price: 35.0,
    description: 'Dolce e vellutato per momenti di relax',
    experienceIds: ['g1', 'g2', 'g6'],
    inStock: true,
    rating: 4.7,
    alcoholContent: '15%',
  },

  // Altri vini versatili
  {
    id: 'w15',
    name: "Montepulciano d'Abruzzo",
    producer: 'Masciarelli',
    year: 2021,
    region: 'Abruzzo',
    type: 'Rosso',
    price: 13.5,
    description: 'Rosso morbido e piacevole per ogni occasione',
    experienceIds: ['a1', 'a3', 'a5', 'c1'],
    inStock: true,
    rating: 4.2,
    alcoholContent: '13.5%',
  },
  {
    id: 'w16',
    name: 'Gavi di Gavi',
    producer: 'La Scolca',
    year: 2022,
    region: 'Piemonte',
    type: 'Bianco',
    price: 19.0,
    description: 'Bianco elegante e raffinato',
    experienceIds: ['a1', 'c2', 'e1', 'e2'],
    inStock: true,
    rating: 4.4,
    alcoholContent: '12.5%',
  },
]
